var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout-report-step',{attrs:{"isDone":_vm.isDone,"title":_vm.header.title,"description":_vm.header.description,"image":_vm.header.image,"debug":_vm.header.debug}},[_c('insurances-form',{on:{"valid":_vm.setValid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }